import React from "react";
import { Paper } from "@mui/material";
import type { PaperProps } from "@mui/material/Paper";
import { alpha } from "@mui/material/styles";
import { AUTH_CARD_MAX_WIDTH_PX } from "./authScreenStyles";

export interface AuthCardProps extends PaperProps {
  /** `narrow` = same width as Recuperar contraseña (400px). `fluid` = full width of parent. */
  layout?: "narrow" | "fluid";
}

const AuthCard: React.FC<AuthCardProps> = ({
  layout = "narrow",
  sx,
  elevation = 0,
  ...props
}) => {
  const narrow = layout === "narrow";
  return (
    <Paper
      elevation={elevation}
      sx={[
        (theme) => ({
          p: 4,
          width: "100%",
          maxWidth: narrow ? AUTH_CARD_MAX_WIDTH_PX : "100%",
          boxSizing: "border-box",
          ...(narrow && { alignSelf: "center" }),
          borderRadius: `${theme.shape.borderRadius}px`,
          border: `1px solid ${theme.palette.divider}`,
          bgcolor: theme.palette.background.paper,
          boxShadow: `0 1px 2px ${alpha(theme.palette.primary.main, theme.palette.mode === "dark" ? 0.12 : 0.08)}`,
        }),
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
      {...props}
    />
  );
};

export default AuthCard;
